// HomePage.js
import React from 'react';
import Hero from '../components/Hero';
import MediaSection from '../components/MediaSection';
import HowItWorksComponent from '../components/HowItWorksComponent';
import AboutUs from '../components/AboutComponent';
import ScamTypes from '../components/ScamTypes';
import Reviews from '../components/Reviews';
import FAQs from '../components/FAQs';


const HomePage = () => {
  return (
    <div>
      <Hero />
      <MediaSection />
      <HowItWorksComponent />
      <AboutUs />
      <ScamTypes />
      {/* <Reviews /> */}
      <FAQs />

      {/* More sections can be added here later */}
    </div>
  );
};

export default HomePage;
